import { render, staticRenderFns } from "./OldHeader.vue?vue&type=template&id=ea0f5d60&"
import script from "./OldHeader.vue?vue&type=script&lang=js&"
export * from "./OldHeader.vue?vue&type=script&lang=js&"
import style0 from "./OldHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports